(function() {
    'use strict';
    
    // Configuration
    const CONFIG = {
        widgetSelector: '[data-rebuy-id]',
        waitTimeout: 45000, // 45 seconds - increased for reliability
        checkInterval: 200, // Check every 200ms
        customClass: 'custom-rebuy-widget'
    };
    
    // Track if transformation has already been done
    let isTransformed = false;
    
    // Wait for Rebuy widget to load and initialize
    function waitForRebuyWidget() {
        return new Promise((resolve, reject) => {
            const startTime = Date.now();
            let attempts = 0;
            
            const checkWidget = () => {
                attempts++;
                const widget = document.querySelector(CONFIG.widgetSelector);
                
                if (widget) {
                    // More flexible content detection
                    const hasContent = widget.querySelector('.rebuy-bundle') || 
                                     widget.querySelector('.rebuy-product-block') ||
                                     widget.querySelector('.rebuy-widget') ||
                                     widget.querySelector('[data-rebuy-id]') ||
                                     widget.innerHTML.trim().length > 100; // Has substantial content
                    
                    if (hasContent) {
                        resolve(widget);
                        return;
                    }
                }
                
                // Reduced timeout and more frequent checks
                if (Date.now() - startTime > 5000) { // 5 seconds max
                    const fallbackWidget = document.querySelector(CONFIG.widgetSelector);
                    if (fallbackWidget) {
                        resolve(fallbackWidget);
                        return;
                    }
                    reject(new Error('No Rebuy widget found'));
                    return;
                }
                
                setTimeout(checkWidget, 200); // Check every 200ms
            };
            
            checkWidget();
        });
    }
    
    // Extract data from Rebuy widget with improved selectors
    function extractWidgetData(widget) {
        const data = {
            title: '',
            description: '',
            products: [],
            totalPrice: { sale: '', compareAt: '' },
            savings: '',
            originalWidget: widget // Store reference to original widget
        };
        
        
        // Extract title and description with multiple selector attempts
        const titleSelectors = ['.primary-title', 'h3', '.rebuy-widget h3'];
        const descSelectors = ['.description', '.rebuy-widget .description'];
        
        for (const selector of titleSelectors) {
            const titleEl = widget.querySelector(selector);
            if (titleEl) {
                data.title = titleEl.textContent.trim();
                break;
            }
        }
        
        for (const selector of descSelectors) {
            const descEl = widget.querySelector(selector);
            if (descEl) {
                let description = descEl.textContent.trim();
                // Make "save 10%" and "Free Express Shipping" bold
                description = description.replace(/(save\s+\d+%)/gi, '<strong>$1</strong>');
                description = description.replace(/(Free\s+Express\s+Shipping)/gi, '<strong>$1</strong>');
                data.description = description;
                break;
            }
        }
        
        // Extract total price with multiple selector attempts
        const priceSelectors = [
            '.rebuy-bundle__actions-price-value',
            '.rebuy-bundle .rebuy-money',
            '.rebuy-widget .rebuy-money'
        ];
        
        for (const selector of priceSelectors) {
            const totalPriceEl = widget.querySelector(selector);
            if (totalPriceEl) {
                const saleEl = totalPriceEl.querySelector('.rebuy-money.sale span:last-child') || 
                              totalPriceEl.querySelector('.sale span') ||
                              totalPriceEl.querySelector('.sale');
                const compareEl = totalPriceEl.querySelector('.rebuy-money.compare-at span:last-child') ||
                                totalPriceEl.querySelector('.compare-at span') ||
                                totalPriceEl.querySelector('.compare-at');
                
                if (saleEl) data.totalPrice.sale = saleEl.textContent.trim();
                if (compareEl) data.totalPrice.compareAt = compareEl.textContent.trim();
                
                // Calculate savings
                if (data.totalPrice.sale && data.totalPrice.compareAt) {
                    const sale = parseFloat(data.totalPrice.sale.replace(/[^0-9.]/g, ''));
                    const compare = parseFloat(data.totalPrice.compareAt.replace(/[^0-9.]/g, ''));
                    if (!isNaN(sale) && !isNaN(compare)) {
                        const savings = compare - sale;
                        data.savings = `$${savings.toFixed(2)}`;
                    }
                }
                break;
            }
        }
        
        // Extract products with improved logic
        const productSelectors = [
            '.rebuy-product-block',
            '.rebuy-bundle__image',
            '.rebuy-widget .product'
        ];
        
        let productBlocks = [];
        for (const selector of productSelectors) {
            productBlocks = widget.querySelectorAll(selector);
            if (productBlocks.length > 0) break;
        }
        
        
        productBlocks.forEach((block, index) => {
            const product = {
                title: '',
                price: { sale: '', compareAt: '' },
                image: '',
                url: '',
                rating: '',
                reviewCount: '',
                tags: [],
                originalElement: block // Store reference to original element
            };
            
            // Product title - try multiple selectors
            const titleSelectors = [
                '.rebuy-product-title',
                'a[href*="/products/"]',
                '.product-title',
                'h4',
                'h3'
            ];
            
            for (const selector of titleSelectors) {
                const titleEl = block.querySelector(selector);
                if (titleEl) {
                    product.title = titleEl.textContent.trim();
                    product.url = titleEl.href || '';
                    break;
                }
            }
            
            // Product price - try multiple selectors
            const priceSelectors = [
                '.rebuy-product-price',
                '.product-price',
                '.price'
            ];
            
            for (const selector of priceSelectors) {
                const priceEl = block.querySelector(selector);
                if (priceEl) {
                    const saleEl = priceEl.querySelector('.rebuy-money.sale span:last-child') ||
                                 priceEl.querySelector('.sale span') ||
                                 priceEl.querySelector('.sale');
                    const compareEl = priceEl.querySelector('.rebuy-money.compare-at span:last-child') ||
                                   priceEl.querySelector('.compare-at span') ||
                                   priceEl.querySelector('.compare-at');
                    
                    if (saleEl) product.price.sale = saleEl.textContent.trim();
                    if (compareEl) product.price.compareAt = compareEl.textContent.trim();
                    break;
                }
            }
            
            // Product image - try multiple approaches
            const imageSelectors = [
                'img',
                '.product-image img',
                '.rebuy-bundle__image img'
            ];
            
            for (const selector of imageSelectors) {
                const imageEl = block.querySelector(selector);
                if (imageEl && imageEl.src) {
                    product.image = imageEl.src;
                    break;
                }
            }
            
            // If no image found in block, try to find it in the bundle
            if (!product.image) {
                const bundle = widget.querySelector('.rebuy-bundle');
                if (bundle) {
                    const images = bundle.querySelectorAll('img');
                    if (images[index]) {
                        product.image = images[index].src;
                    }
                }
            }
            
            // Rating and reviews
            const ratingEl = block.querySelector('.rebuy-star-rating-value') || 
                           block.querySelector('.rating');
            const reviewEl = block.querySelector('.rebuy-review-count-number') ||
                           block.querySelector('.review-count');
            
            if (ratingEl) product.rating = ratingEl.textContent.trim();
            if (reviewEl) product.reviewCount = reviewEl.textContent.trim();
            
            // Tags
            const classList = block.className.split(' ');
            product.tags = classList.filter(cls => cls.startsWith('tag-')).map(tag => tag.replace('tag-', ''));
            
            // Only add product if we have at least a title
            if (product.title) {
                data.products.push(product);
            }
        });
        
        return data;
    }
    
    // Create custom widget HTML with improved layout
    function createCustomWidget(data) {
        // If no products found, don't show anything
        if (data.products.length === 0) {
            return '';
        }
        
        // Get the second product name for the title
        let secondProductName = '';
        if (data.products.length >= 2) {
            secondProductName = data.products[1].title;
        }
        
        // Modify the title to use the second product name
        let customTitle = data.title;
        if (secondProductName && customTitle) {
            // Replace "Ashwagandha capsules" or similar with the second product name
            customTitle = customTitle.replace(/The product is frequently purchased with [^<]+/, 
                `The product is frequently purchased with ${secondProductName}`);
        }
        
        const productsHTML = data.products.map((product, index) => {
            // Create star rating HTML
            let starsHTML = '';
            if (product.rating) {
                const ratingValue = parseFloat(product.rating.split(' ')[0]); // Extract number from "4.8 stars out of 5 stars"
                const fullStars = Math.floor(ratingValue);
                const hasHalfStar = ratingValue % 1 >= 0.5;
                const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);
                
                starsHTML = `
                    <div class="product-rating">
                        <div class="star-rating">
                            ${Array(fullStars).fill('<span class="star full">★</span>').join('')}
                            ${hasHalfStar ? '<span class="star half">★</span>' : ''}
                            ${Array(emptyStars).fill('<span class="star empty">☆</span>').join('')}
                        </div>
                        ${product.reviewCount ? `<span class="reviews">(${product.reviewCount} reviews)</span>` : ''}
                    </div>
                `;
            }
            
            return `
                <div class="custom-product" onclick="openProductPage('${product.url}')" style="cursor: pointer;">
                    <div class="product-image">
                        <img src="${product.image || 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjYwIiBoZWlnaHQ9IjYwIiBmaWxsPSIjRjNGNEY2Ii8+CjxwYXRoIGQ9Ik0yMCAyMEg0MFY0MEgyMFYyMFoiIGZpbGw9IiNEMUQ1REIiLz4KPC9zdmc+'}" alt="${product.title}" loading="lazy">
                    </div>
                    <div class="product-info">
                        <h4 class="product-title">${product.title}</h4>
                        ${starsHTML}
                        <div class="product-price">
                            <span class="sale-price">${product.price.sale || 'Price not available'}</span>
                            ${product.price.compareAt ? `<span class="compare-price">${product.price.compareAt}</span>` : ''}
                        </div>
                    </div>
                </div>
            `;
        }).join('');
        
        return `
            <div class="${CONFIG.customClass}">
                ${customTitle ? `
                    <div class="widget-header">
                        <h3 class="widget-title">${customTitle}</h3>
                        ${data.description ? `<p class="widget-description">${data.description}</p>` : ''}
                    </div>
                ` : ''}
                
                <div class="products-container">
                    ${productsHTML}
                </div>
                
                <div class="widget-footer">
                    ${(data.totalPrice.sale || data.totalPrice.compareAt) ? `
                        <div class="price-summary">
                            <div class="price-info">
                                <div class="total-price">
                                    <span class="label">Total:</span>
                                    <span class="sale-price">${data.totalPrice.sale || 'Price not available'}</span>
                                    ${data.totalPrice.compareAt ? `<span class="compare-price">${data.totalPrice.compareAt}</span>` : ''}
                                </div>
                                ${data.savings ? `<div class="savings">Save ${data.savings}</div>` : ''}
                            </div>
                            <button class="add-to-cart-btn" onclick="triggerOriginalRebuyAddToCart()">
                                <span>Add both to cart</span>
                            </button>
                        </div>
                    ` : `
                        <div class="price-summary">
                            <div class="price-info">
                                <div class="total-price">
                                    <span class="label">Bundle Offer</span>
                                </div>
                            </div>
                            <button class="add-to-cart-btn" onclick="triggerOriginalRebuyAddToCart()">
                                <span>Add both to cart</span>
                            </button>
                        </div>
                    `}
                </div>
            </div>
        `;
    }
    
    // Add custom styles
    function addCustomStyles() {
        const styleId = 'custom-rebuy-widget-styles';
        if (document.getElementById(styleId)) return;
        
        const styles = `
            <style id="${styleId}">
                .${CONFIG.customClass} {
                    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
                    width: 100%;
                    max-width: none;
                    margin: 20px 0;
                    padding: 20px;
                    background: #F9F8F4;
                    border-radius: 12px;
                }
                
                .${CONFIG.customClass} .widget-header {
                    text-align: center;
                    margin-bottom: 20px;
                }
                
                .${CONFIG.customClass} .widget-title {
                    font-size: 1.1rem;
                    font-weight: 600;
                    color: #1f2937;
                    margin: 0 0 8px 0;
                    line-height: 1.2;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
                
                .${CONFIG.customClass} .widget-description {
                    font-size: 0.95rem;
                    color: #6b7280;
                    margin: 0;
                }
                
                .${CONFIG.customClass} .products-container {
                    display: flex;
                    gap: 16px;
                    margin-bottom: 20px;
                }
                
                .${CONFIG.customClass} .custom-product {
                    flex: 1;
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    padding: 12px;
                    background: #ffffff;
                    border-radius: 8px;
                    border: 1px solid #e5e7eb;
                    transition: all 0.2s ease;
                }
                
                .${CONFIG.customClass} .custom-product:hover {
                    background: #f9fafb;
                    transform: translateY(-1px);
                }
                
                .${CONFIG.customClass} .product-image {
                    flex-shrink: 0;
                }
                
                .${CONFIG.customClass} .product-image img {
                    width: 60px;
                    height: 60px;
                    object-fit: cover;
                    border-radius: 6px;
                }
                
                .${CONFIG.customClass} .product-info {
                    flex: 1;
                    min-width: 0;
                }
                
                .${CONFIG.customClass} .product-title {
                    font-size: 0.9rem;
                    font-weight: 500;
                    color: #1f2937;
                    margin: 0 0 4px 0;
                    line-height: 1.3;
                }
                
                .${CONFIG.customClass} .product-rating {
                    font-size: 0.8rem;
                    color: #6b7280;
                    margin-bottom: 4px;
                    display: flex;
                    align-items: center;
                    gap: 4px;
                }
                
                .${CONFIG.customClass} .star-rating {
                    display: flex;
                    align-items: center;
                    gap: 1px;
                }
                
                .${CONFIG.customClass} .star {
                    font-size: 0.9rem;
                    line-height: 1;
                }
                
                .${CONFIG.customClass} .star.full {
                    color: #fbbf24;
                }
                
                .${CONFIG.customClass} .star.half {
                    color: #fbbf24;
                    opacity: 0.7;
                }
                
                .${CONFIG.customClass} .star.empty {
                    color: #d1d5db;
                }
                
                .${CONFIG.customClass} .reviews {
                    color: #6b7280;
                    font-size: 0.75rem;
                }
                
                .${CONFIG.customClass} .product-price {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                }
                
                .${CONFIG.customClass} .sale-price {
                    font-weight: 600;
                    color: #1f2937;
                    font-size: 0.9rem;
                }
                
                .${CONFIG.customClass} .compare-price {
                    font-size: 0.8rem;
                    color: #9ca3af;
                    text-decoration: line-through;
                }
                
                .${CONFIG.customClass} .widget-footer {
                    border-top: 1px solid #e5e7eb;
                    padding-top: 16px;
                }
                
                .${CONFIG.customClass} .price-summary {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 16px;
                }
                
                .${CONFIG.customClass} .total-price {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                }
                
                .${CONFIG.customClass} .total-price .label {
                    font-weight: 500;
                    color: #374151;
                }
                
                .${CONFIG.customClass} .total-price .sale-price {
                    font-size: 1.2rem;
                    font-weight: 700;
                }
                
                .${CONFIG.customClass} .savings {
                    font-size: 0.9rem;
                    color: #059669;
                    font-weight: 500;
                }
                
                .${CONFIG.customClass} .price-info {
                    display: flex;
                    flex-direction: column;
                    gap: 4px;
                }
                
                .${CONFIG.customClass} .add-to-cart-btn {
                    background: #000000;
                    color: white;
                    border: none;
                    padding: 14px 24px;
                    border-radius: 8px;
                    font-size: 1rem;
                    font-weight: 600;
                    cursor: pointer;
                    transition: background-color 0.2s;
                    text-align: center;
                    min-width: 140px;
                }
                
                .${CONFIG.customClass} .add-to-cart-btn:hover {
                    background: #1a1a1a;
                }
                
                .${CONFIG.customClass} .add-to-cart-btn:active {
                    transform: translateY(1px);
                }
                
                /* Hide original complementary products when custom widget is shown */
                .product-info__complementary-products {
                    display: none !important;
                }
                
                @media (max-width: 640px) {
                    .${CONFIG.customClass} {
                        margin: 10px 0;
                        padding: 16px;
                    }
                    
                    .${CONFIG.customClass} .widget-title {
                        font-size: 1rem;
                        white-space: normal;
                    }
                    
                    .${CONFIG.customClass} .products-container {
                        flex-direction: column;
                    }
                    
                    .${CONFIG.customClass} .custom-product {
                        flex-direction: row;
                    }
                    
                    .${CONFIG.customClass} .price-summary {
                        flex-direction: row;
                        align-items: center;
                        gap: 12px;
                        justify-content: space-between;
                    }
                    
                    .${CONFIG.customClass} .price-info {
                        flex: 1;
                    }
                    
                    .${CONFIG.customClass} .add-to-cart-btn {
                        flex-shrink: 0;
                        min-width: 120px;
                        padding: 12px 16px;
                        font-size: 0.9rem;
                    }
                    
                    .${CONFIG.customClass} .total-price .label {
                        display: none;
                    }
                }
            </style>
        `;
        
        document.head.insertAdjacentHTML('beforeend', styles);
    }
    
    // Replace original widget with custom widget
    function replaceWidget(originalWidget, customHTML) {
        // Check if already transformed
        if (document.querySelector(`.${CONFIG.customClass}`)) {
            return;
        }
        
        // If no custom HTML (no products found), hide the original widget completely
        if (!customHTML || customHTML.trim() === '') {
            originalWidget.style.display = 'none';
            return;
        }
        
        // Hide original widget
        originalWidget.style.display = 'none';
        
        // Insert custom widget after original
        originalWidget.insertAdjacentHTML('afterend', customHTML);
        
        // Mark as transformed
        isTransformed = true;
    }
    
    // Function to trigger original Rebuy add to cart
    window.triggerOriginalRebuyAddToCart = function() {
        // Find the original Rebuy add to cart button and click it
        const originalWidget = document.querySelector(CONFIG.widgetSelector);
        if (originalWidget) {
            const originalButton = originalWidget.querySelector('.rebuy-button');
            if (originalButton) {
                originalButton.click();
            } else {
            }
        }
    };
    
    // Function to open product page
    window.openProductPage = function(url) {
        if (url) {
            window.open(url, '_blank');
        }
    };
    
    // Main function to transform widget
    async function transformRebuyWidget() {
        // Prevent multiple transformations
        if (isTransformed) {
            return;
        }
        
        
        try {
            // Wait for widget to load
            const widget = await waitForRebuyWidget();
            
            // Extract data
            const data = extractWidgetData(widget);
            
            // Add custom styles
            addCustomStyles();
            
            // Create and insert custom widget
            const customHTML = createCustomWidget(data);
            
            replaceWidget(widget, customHTML);
            
            isTransformed = true;
            
        } catch (error) {
            
            // Fallback: try to find any Rebuy widget and transform it even if not fully initialized
            const fallbackWidget = document.querySelector(CONFIG.widgetSelector);
            if (fallbackWidget) {
                try {
                    const data = extractWidgetData(fallbackWidget);
                    addCustomStyles();
                    const customHTML = createCustomWidget(data);
                    replaceWidget(fallbackWidget, customHTML);
                    isTransformed = true;
                } catch (fallbackError) {
                }
            } else {
            }
        }
    }
    
    // Initialize when DOM is ready
    function initialize() {
        
        // Try immediate transformation
        setTimeout(() => {
            transformRebuyWidget();
        }, 1000);
        
        // Also try after a longer delay in case Rebuy loads later
        setTimeout(() => {
            if (!isTransformed) {
                transformRebuyWidget();
            }
        }, 3000);
    }
    
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initialize);
    } else {
        initialize();
    }
    
    // Optional: Listen for Rebuy events as additional triggers (but only if not already transformed)
    document.addEventListener('rebuyReady', () => {
        if (!isTransformed) {
            setTimeout(transformRebuyWidget, 500);
        }
    });
    
    document.addEventListener('rebuy:widget:ready', () => {
        if (!isTransformed) {
            setTimeout(transformRebuyWidget, 1000);
        }
    });
    
    document.addEventListener('rebuy:widget:loaded', () => {
        if (!isTransformed) {
            setTimeout(transformRebuyWidget, 1000);
        }
    });
    
})();
